import type { ReactNode } from "react"

import { cn } from "../../lib/utils"

type GlassCardProps = {
  children: ReactNode
  className?: string
}

export function GlassCard({ children, className }: GlassCardProps) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-white/10 bg-white/5 p-6 shadow-xl backdrop-blur-xl",
        className
      )}
    >
      {children}
    </div>
  )
}
